import { render } from "./automatic-discharge-report-settings.vue?vue&type=template&id=2fe1a7d0&ts=true"
import script from "./automatic-discharge-report-settings.vue?vue&type=script&lang=ts"
export * from "./automatic-discharge-report-settings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__